import { useQuery, useZero } from "@rocicorp/zero/react";
import { styled } from "goober";
import { sharedMutators } from "../../shared/mutators";
import { queries } from "../../shared/queries";
import { pluralize } from "../lib/inflection";
import { Button } from "./Button";
import { Modal } from "./Modal";
import { Text } from "./Text";
import { WorkflowPreviewList } from "./WorkflowPreviewList";

const Content = styled("div")`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 320px;
`;

const Footer = styled("div")`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export function DeleteSpaceModal({
  spaceId,
  spaceName,
  onClose,
  onDeleted,
}: {
  spaceId: string;
  spaceName: string;
  onClose: () => void;
  onDeleted?: () => void;
}) {
  const z = useZero();
  const [workflows, workflowsResult] = useQuery(
    queries.spaceDeletionPreviewWorkflows({ spaceId })
  );
  const loading = workflowsResult.type !== "complete";

  return (
    <Modal open onClose={onClose} alert>
      <Content>
        <Text variant="text-regular-md" color="var(--text-primary)">
          Delete space
        </Text>
        {loading ? (
          <Text variant="text-regular" color="var(--text-secondary)">
            Loading workflows…
          </Text>
        ) : workflows.length === 0 ? (
          <Text variant="text-regular" color="var(--text-secondary)">
            Permanently deletes “{spaceName}” and everything in it — workflows,
            steps, and runs.
          </Text>
        ) : (
          <Text variant="text-regular" color="var(--text-secondary)">
            Move or delete the {workflows.length}{" "}
            {pluralize("workflow", workflows.length)} in “{spaceName}” before
            deleting this space.
          </Text>
        )}
        {!loading && <WorkflowPreviewList workflows={workflows} />}
        <Footer>
          <Button size="l" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="l"
            variant="danger"
            disabled={loading || workflows.length > 0}
            onClick={() => {
              z.mutate(sharedMutators.deleteSpace({ spaceId }));
              onDeleted?.();
              onClose();
            }}
          >
            Delete space
          </Button>
        </Footer>
      </Content>
    </Modal>
  );
}
